// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import AddedtoBagDynamicStore from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBagDynamicStore.js';
import ColorSwatches from './ColorSwatches';
import { SubmitButton, SubmitButtonWrapper } from './styles/SubmitButton.style';
import ZoneOneBadges from './ZoneOneBadges.view';
import ZoneSixBadges from './ZoneSixBadges.view';
import PointsAndRewards from './PointsAndrewards';
import PromotionalMessage from './PromotionalMessage';
import { ZoneOneBadgesWrapper } from './styles/ZoneOneBadges.style';
import plpTileLocators from './plpTileLocators';
import { getAddToBagButtonText } from './plpTileHelpers/slpTileHelper';

export const renderColorSwatches = ({
  productPartNo,
  TCPSwatches,
  onQuickViewOpenClick,
  assetHost,
  assetPath,
  saveDataForQv,
  swatchImg,
  tcpColor,
  auxDescription,
  relatedSwatchImages,
  isBundle,
  handleClick,
  isNewSwatchUrlEnabled,
  isMountedTileRedesignAB,
  isDynamicColorSwatchesEnabled,
  isHoverToPreviewColorSwatchesEnabled,
  handleHoverOnColorSwatch,
  handleMouseLeave,
  productStyleType,
  isSwatchAsColorUrlEnabled,
}) => {
  return (
    <ColorSwatches
      productPartNo={productPartNo}
      TCPSwatches={TCPSwatches}
      onQuickViewOpenClick={onQuickViewOpenClick}
      assetHost={assetHost}
      assetPath={assetPath}
      saveDataForQv={saveDataForQv}
      swatchImg={swatchImg}
      tcpColor={tcpColor}
      auxDescription={auxDescription}
      relatedSwatchImages={relatedSwatchImages}
      isBundleProduct={isBundle}
      handleViewBundleClick={handleClick}
      AddedtoBagDynamicStore={AddedtoBagDynamicStore}
      isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
      isTileRedesignAB={isMountedTileRedesignAB}
      isSLPTile
      isDynamicColorSwatchesEnabled={isDynamicColorSwatchesEnabled}
      isHoverToPreviewColorSwatchesEnabled={isHoverToPreviewColorSwatchesEnabled}
      handleMouseEnter={handleHoverOnColorSwatch}
      handleMouseLeave={handleMouseLeave}
      productStyleType={productStyleType}
      isSwatchAsColorUrlEnabled={isSwatchAsColorUrlEnabled}
    />
  );
};

export const renderZoneSixBadges = ({ zoneSixBadges }) => {
  if (zoneSixBadges) {
    return <ZoneSixBadges text={zoneSixBadges} />;
  }
  return null;
};

export const renderBadge = ({ zoneOneBadgesArray }) => {
  if (zoneOneBadgesArray?.length > 0) {
    return (
      <ZoneOneBadgesWrapper>
        {zoneOneBadgesArray.map((badge) => {
          return (
            <ZoneOneBadges key={badge.priority.toString()} type={badge.type} text={badge.label} />
          );
        })}
      </ZoneOneBadgesWrapper>
    );
  }
  return <ZoneOneBadgesWrapper />;
};

export const renderSubmitButtonVanilla = ({
  isBundle,
  submitButtonText,
  pickupInStore,
  primaryBrand,
  shopTheLook,
  shopCollection,
  handleClick,
  hasMounted,
  isMountedHoverToRevealATBButtonEnabled,
}) => {
  const addToBagButtonText = getAddToBagButtonText({
    isBundle,
    submitButtonText,
    pickupInStore,
    primaryBrand,
    shopTheLook,
    shopCollection,
  });
  return (
    <SubmitButton
      brand={primaryBrand}
      isBundleProduct={isBundle}
      onClick={() => {
        setTimeout(async () => {
          await AddedtoBagDynamicStore();
          handleClick();
        }, 0);
      }}
      data-locator={plpTileLocators.addToBagBtn}
      isPLP
      hasMounted={hasMounted}
      className={`${isMountedHoverToRevealATBButtonEnabled ? 'reveal-atb-button' : ''}${
        hasMounted ? ' display-inline-block' : ''
      }`}
    >
      {addToBagButtonText}
    </SubmitButton>
  );
};

export const renderSubmitButton = ({
  isBundle,
  submitButtonText,
  pickupInStore,
  primaryBrand,
  shopTheLook,
  shopCollection,
  handleClick,
  hasMounted,
  isMountedHoverToRevealATBButtonEnabled,
}) => {
  return (
    <SubmitButtonWrapper className="tile-redesign">
      {renderSubmitButtonVanilla({
        isBundle,
        submitButtonText,
        pickupInStore,
        primaryBrand,
        shopTheLook,
        shopCollection,
        handleClick,
        hasMounted,
        isMountedHoverToRevealATBButtonEnabled,
      })}
    </SubmitButtonWrapper>
  );
};

export const renderPointsAndPromotion = ({
  isBrierleyPromoEnabled,
  pointsAndRewardsText,
  promotionalMessage,
  promotionalPLCCMessage,
  isPlcc,
  isInternationalShipping,
}) => {
  return isBrierleyPromoEnabled ? (
    <PointsAndRewards
      isBrierleyPromoEnabled={isBrierleyPromoEnabled}
      pointsAndRewardsText={pointsAndRewardsText}
    />
  ) : (
    <PromotionalMessage
      promotionalMessage={promotionalMessage}
      promotionalPLCCMessage={promotionalPLCCMessage}
      isPlcc={isPlcc}
      isInternationalShipping={isInternationalShipping}
    />
  );
};
